/**
 * Normaliza texto plano para DTE / PDF Facele: ASCII práctico, sin acentos ni superscriptos.
 * - NFKC convierte compatibilidad (p. ej. m³ → m3).
 * - NFD + quitar marcas combinatorias elimina tildes y diéresis (Ácido → Acido).
 * - Unifica guiones y espacios tipográficos frecuentes.
 * - Corrige mojibake comunes (Â° → °) y convierte ° → o (N° → No).
 *
 * No elimina saltos de línea (\n); se preservan para el layout acordado con formatDscItem.
 */
export function normalizeFacelePlainText(str) {
	if (str == null || typeof str !== 'string') return str;

	return str
		.replace(/\r\n/g, '\n')
		.replace(/\r/g, '\n')
		.replace(/\xc2\xb0/g, '\u00b0')
		.normalize('NFKC')
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.replace(/\u00b0/g, 'o')
		.replace(/[\u2013\u2014\u2212]/g, '-')
		.replace(/[\u00a0\u202f\u2007]/g, ' ')
		.replace(/[\u2018\u2019]/g, "'")
		.replace(/[\u201c\u201d]/g, '"');
}
